import { BoxContainer, PrimaryButton, ReactIcons, SimpleButton } from "@kalyzee/kalyzee-ui";
import { useMeetingSelector } from "@kalyzee/kast-web-sdk";
import { QRCode } from "@kalyzee/kast-web-sdk/web-components";
import React, { useCallback, useMemo } from "react";
import { useMeetingContainerContext } from "../../contexts/meetingContainer/context";
import { toastError, toastSuccess } from "../../helpers/toast";
import workBoxStyles from "./WorkBox.module.css";
import styles from "./ShareWorkBox.module.css";

export interface ShareWorkBoxProps {
  onClose?: () => void;
}

export const ShareWorkBox: React.FC<ShareWorkBoxProps> = ({ onClose }) => {
  const { containerAPI } = useMeetingContainerContext();
  const [shortId] = useMeetingSelector(containerAPI, "meeting", meeting => meeting?.shortId);

  const shareUrl = useMemo(() => {
    if (!shortId) return undefined;
    const url = new URL(window.location.href);
    url.pathname = `/j/${shortId}`;
    url.search = "";
    url.hash = "";
    return url.toString();
  }, [shortId]);

  const onCopy = useCallback(() => {
    if (!shareUrl) return;
    navigator.clipboard.writeText(shareUrl).then(() => {
      toastSuccess("Lien copié dans le presse-papier");
    }).catch(err => {
      toastError("Impossible de copier le lien dans le presse-papier");
      console.error("Failed to copy share URL: ", err);
    });
  }, [shareUrl]);

  const right: React.ReactNode[] = [];
  if (onClose) {
    right.push(
      <PrimaryButton key="close" onClick={onClose}>
        <ReactIcons.Close style={{ height: "0.8em" }} />
      </PrimaryButton>
    );
  }

  return (
    <BoxContainer
      style={{ width: "100%", height: "100%" }}
      topBarProps={{
        left: [<ReactIcons.QRCode key="qr-icon" style={{ width: "1.5em", height: "1.5em" }} />],
        center: [<span key="title" className={workBoxStyles.label}>Partager le meeting</span>],
        right,
      }}
    >
      <div className={styles.body}>
        {shareUrl ? (
          <>
            <div className={styles.qrCard}>
              <QRCode text={shareUrl} className={styles.qr} />
            </div>

            <span className={styles.label}>Lien d'invitation</span>

            <div className={styles.linkRow}>
              <span className={styles.linkText} title={shareUrl}>{shareUrl}</span>
              <SimpleButton
                className={styles.copyBtn}
                onClick={onCopy}
                label="Copier"
              />
            </div>
          </>
        ) : null}
      </div>
    </BoxContainer>
  );
};
